import { Menu, Icon } from 'semantic-ui-react';

const LogOutMenuItem = () => {
  return (
    <Menu.Item as="a" href={window.REACT_APP_LOG_OUT_URL}>
      <Icon name="log out" />
    </Menu.Item>
  );
};

export default LogOutMenuItem;
